import { render, staticRenderFns } from "./labelGroup.vue?vue&type=template&id=42bbbc88&scoped=true&"
import script from "./labelGroup.vue?vue&type=script&lang=js&"
export * from "./labelGroup.vue?vue&type=script&lang=js&"
import style0 from "./labelGroup.vue?vue&type=style&index=0&id=42bbbc88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbbc88",
  null
  
)

export default component.exports